module.exports = __webpack_public_path__ + "static/img/kjcz_x.ea478bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kjcz_x.png
// module id = 8LID
// module chunks = 1